import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./loginPage.css";
import SpinnerLoader from "../../spinnerLoader/SpinnerLoader";
import { logIn } from "../../../helpers/api";

export default function LoginPageAUTOTEK360() {
  const [showSpinner, setShowSpinner] = useState(true);
  const [user, setUser] = useState({ username: "", password: "" });
  const [showLoading, setShowLoading] = useState(false);
  const [loginError, setloginError] = useState("");
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();
  const canvasRef = useRef(null);

  const handlerUsername = (e) => setUser({ ...user, username: e.target.value });
  const handlerPassword = (e) => setUser({ ...user, password: e.target.value });

  const handlerLogin = (e) => {
    e.preventDefault();
    if (showLoading) return;
    setShowLoading(true);
    logIn(user)
      .then(() => {
        setShowLoading(false);
        navigate("/applications");
      })
      .catch((error) => {
        setShowLoading(false);
        setloginError(error);
      });
  };

  useEffect(() => {
    setShowSpinner(false);
  }, []);

  useEffect(() => {
    setloginError("");
  }, [user]);

  /* las rayas de luz: se calculan una sola vez */
  const streaks = useMemo(
    () =>
      Array.from({ length: 60 }, (_, i) => ({
        key: i,
        cls:
          (Math.random() < 0.18 ? "thick " : "") +
          (Math.random() < 0.22 ? "white" : ""),
        style: {
          top: (Math.random() * 100).toFixed(2) + "%",
          width: (8 + Math.random() * 40).toFixed(1) + "vw",
          "--d": (4 + Math.random() * 7).toFixed(2) + "s",
          "--dl": (-Math.random() * 9).toFixed(2) + "s",
          "--o": (0.3 + Math.random() * 0.6).toFixed(2),
        },
      })),
    []
  );

  /* particulas turquesa */
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const cv = canvasRef.current;
    if (!cv) return;
    const cx = cv.getContext("2d");
    let raf = 0;
    let dots = [];
    let w = 0;
    let h = 0;

    const size = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = cv.width = cv.offsetWidth * dpr;
      h = cv.height = cv.offsetHeight * dpr;
      dots = Array.from({ length: 80 }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        r: (Math.random() * 1.8 + 0.4) * dpr,
        vx: (Math.random() - 0.2) * 0.28 * dpr,
        vy: (Math.random() - 0.5) * 0.16 * dpr,
        a: Math.random() * 0.55 + 0.12,
        t: Math.random() * 6.28,
      }));
    };

    const draw = () => {
      cx.clearRect(0, 0, w, h);
      for (const p of dots) {
        p.x += p.vx;
        p.y += p.vy;
        p.t += 0.02;
        if (p.x > w + 10) p.x = -10;
        if (p.x < -10) p.x = w + 10;
        if (p.y > h + 10) p.y = -10;
        if (p.y < -10) p.y = h + 10;
        const a = p.a * (0.55 + 0.45 * Math.sin(p.t));
        cx.beginPath();
        cx.arc(p.x, p.y, p.r, 0, 6.283);
        cx.fillStyle = "rgba(140,255,246," + a.toFixed(3) + ")";
        cx.shadowBlur = 8;
        cx.shadowColor = "rgba(22,224,208,.8)";
        cx.fill();
      }
      raf = requestAnimationFrame(draw);
    };

    size();
    draw();
    window.addEventListener("resize", size);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", size);
    };
  }, []);

  const brand = process.env.REACT_APP_BRAND_IMAGE || "bigAutotek.png";
  const title = process.env.REACT_APP_TITLE || "AUTOTEK360";

  return (
    <div className="at-stage">
      <div
        className="at-photo"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/img/heroAutotek.jpg)`,
        }}
      />
      <div className="at-glow" />
      <div className="at-streaks">
        {streaks.map((s) => (
          <span key={s.key} className={s.cls} style={s.style} />
        ))}
      </div>
      <canvas className="at-motes" ref={canvasRef} />

      <section className="at-panel">
        <form className="at-card" onSubmit={handlerLogin} autoComplete="off">
          <img className="at-brand" style={{ "--i": 0 }} src={`img/${brand}`} alt={title} />

          <div className="at-eyebrow" style={{ "--i": 1 }}>
            Welcome back
          </div>
          <h1 className="at-title" style={{ "--i": 2 }}>
            USER <em>LOGIN</em>
          </h1>
          <p className="at-sub" style={{ "--i": 3 }}>
            Log in to continue in our website
          </p>

          {loginError !== "" && (
            <div className="at-error" style={{ "--i": 4 }}>
              {String(loginError)}
            </div>
          )}

          <div className="at-field" style={{ "--i": 5 }}>
            <input
              id="at-user"
              type="text"
              placeholder=" "
              value={user.username}
              onChange={handlerUsername}
            />
            <label htmlFor="at-user">Username</label>
            <svg className="at-ico" viewBox="0 0 24 24">
              <circle cx="12" cy="8" r="3.6" />
              <path d="M4.5 20c.6-4 3.7-6 7.5-6s6.9 2 7.5 6" />
            </svg>
            <div className="at-under" />
          </div>

          <div className="at-field" style={{ "--i": 6 }}>
            <input
              id="at-pass"
              type={showPass ? "text" : "password"}
              placeholder=" "
              value={user.password}
              onChange={handlerPassword}
            />
            <label htmlFor="at-pass">Password</label>
            <svg className="at-ico" viewBox="0 0 24 24">
              <rect x="4.5" y="10.5" width="15" height="9.5" rx="2.2" />
              <path d="M8 10.5V7.6a4 4 0 018 0v2.9" />
            </svg>
            <button
              type="button"
              className="at-eye"
              aria-label={showPass ? "Hide password" : "Show password"}
              onClick={() => setShowPass(!showPass)}
            >
              <svg viewBox="0 0 24 24">
                <path d="M2 12s3.8-6.2 10-6.2S22 12 22 12s-3.8 6.2-10 6.2S2 12 2 12z" />
                <circle cx="12" cy="12" r="2.7" />
                {showPass && <path d="M4 4l16 16" />}
              </svg>
            </button>
            <div className="at-under" />
          </div>

          <button className="at-btn" type="submit" disabled={showLoading} style={{ "--i": 7 }}>
            <span className="at-shine" />
            {showLoading && <span className="at-spin" />}
            {showLoading ? "" : "LOG IN"}
          </button>

          <p className="at-foot" style={{ "--i": 8 }}>
            Protegido por <b>{title}</b> &middot; Acceso autorizado
          </p>
        </form>
      </section>

      <SpinnerLoader show={showSpinner} />
    </div>
  );
}
